import { z } from "zod";

/**
 * Slack Bot Profile Schemas
 *
 * For updating Slack bot profile (photo, name, etc.)
 * Similar to telegram-bot-profile.schema.ts
 */

// Path variables
export const UpdateSlackBotProfilePathVarsSchema = z.object({
  id: z.string().uuid()
});

// Request body
export const UpdateSlackBotProfileBodySchema = z.object({
  /** URL of image to use as bot profile photo */
  photoUrl: z.string().url().optional(),

  /** Bot display name (note: may not work due to Slack API limitations) */
  displayName: z.string().optional()
});

// Bot info response
export const SlackBotInfoSchema = z.object({
  userId: z.string(),
  teamId: z.string(),
  photoUrl: z.string().optional()
});

// Response data
export const UpdateSlackBotProfileResponseSchema = z.object({
  success: z.boolean(),
  botInfo: SlackBotInfoSchema,
  updatedFields: z.array(z.string())
});

// Type exports
export type UpdateSlackBotProfilePathVars = z.infer<typeof UpdateSlackBotProfilePathVarsSchema>;
export type UpdateSlackBotProfileBody = z.infer<typeof UpdateSlackBotProfileBodySchema>;
export type SlackBotInfo = z.infer<typeof SlackBotInfoSchema>;
export type UpdateSlackBotProfileResponse = z.infer<typeof UpdateSlackBotProfileResponseSchema>;
